/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Cargo_ChecklistInputs */

const en_audit_cargo_checklist = /** @type {(inputs: Audit_Cargo_ChecklistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargo Checklist`)
};

const es_audit_cargo_checklist = /** @type {(inputs: Audit_Cargo_ChecklistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lista de Verificacion de Carga`)
};

/**
* | output |
* | --- |
* | "Cargo Checklist" |
*
* @param {Audit_Cargo_ChecklistInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const audit_cargo_checklist = /** @type {((inputs?: Audit_Cargo_ChecklistInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Cargo_ChecklistInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_cargo_checklist(inputs)
	return es_audit_cargo_checklist(inputs)
});